module.exports = __webpack_public_path__ + "static/grainFree-a8dbb3013d6f7c8cfe02419fce37b9df.png";